// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3nThN","left":"InfoRow_left__gSni5"};